module.exports = __webpack_public_path__ + "img/profil_lapper_ana-lucia.3740ddb6.png";